/**
 * Created by Matteo on 11/07/2015.
 */
define('loginMainRouter',[
  'require',
  'exports',
  'module',
  'marionette',
  'app'
], function(
  require,
  exports,
  module,
  Marionette,
  App
) {
  'use strict';

  var LoginRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'login': 'showLogin'
    }
  });

  var API = {
    showLogin: function(){
      require(['loginShowController'], function(ShowController) {
        App.startSubModule('loginMain');
        ShowController.showLogin();
      });
    }
  };

  App.on('login:show', function() {
    App.navigate('login');
    API.showLogin();
  });

  App.on('before:start', function() {
    new LoginRouter({
      controller: API
    });
  });

  module.exports = LoginRouter;
});

